import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TRABADJU_INFO as T } from '@/utils/businessInfo';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Termos() {
  const { t } = useTranslation();
  const today = new Date().toLocaleDateString('pt-PT');
  return (
    <div className="min-h-screen bg-gray-50 py-10" data-testid="page-termos">
      <div className="max-w-3xl mx-auto px-4">
        <Link to="/"><Button variant="ghost" className="mb-4"><ArrowLeft className="h-4 w-4 mr-2" />{t('legal.back')}</Button></Link>
        <article className="bg-white rounded-xl shadow-sm p-8 prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold mb-2">{t('legal.termsTitle')}</h1>
          <p className="text-sm text-gray-500 mb-2">{t('legal.lastUpdated', { date: today })}</p>
          <p className="text-xs text-gray-400 mb-6 not-italic">{t('legal.ptOnlyNotice')}</p>

          <h2>1. Identificação do prestador de serviços</h2>
          <p>O serviço <strong>{T.brand}</strong>, disponibilizado em {T.website}, é fornecido por:</p>
          <ul>
            <li><strong>{T.legal_name}</strong></li>
            <li>NIF: {T.nif}</li>
            <li>Sede: {T.address}</li>
            <li>Contacto: <a href={`mailto:${T.email_public}`}>{T.email_public}</a></li>
          </ul>

          <h2>2. Objecto</h2>
          <p>O Trabadju é uma plataforma digital de classificados de emprego em Cabo Verde, que permite a empregadores publicar vagas de emprego mediante a aquisição de créditos (modelo <em>pay-per-post</em>) e a candidatos pesquisar e candidatar-se a vagas gratuitamente.</p>

          <h2>3. Aceitação dos Termos</h2>
          <p>Ao registar-se ou utilizar o Trabadju, o utilizador declara ter lido, compreendido e aceitar integralmente estes Termos e a Política de Privacidade. Se não concordar, deverá abster-se de utilizar a plataforma.</p>

          <h2>4. Tipos de utilizador</h2>
          <ul>
            <li><strong>Candidato</strong> — pessoa singular que cria perfil para se candidatar a vagas. Acesso e candidaturas gratuitos.</li>
            <li><strong>Empregador</strong> — pessoa singular ou colectiva que publica vagas adquirindo créditos.</li>
          </ul>

          <h2>5. Créditos e Pacotes</h2>
          <ul>
            <li><strong>Gratuito</strong> — 1 anúncio activo de cada vez, válido 30 dias. Disponível sem limite de tempo.</li>
            <li><strong>Anúncio Simples</strong> — 1.500 CVE, 1 anúncio, 30 dias.</li>
            <li><strong>Anúncio Destaque</strong> — 3.000 CVE, 1 anúncio em destaque, 30 dias.</li>
            <li><strong>Pack 5 Anúncios</strong> — 6.000 CVE, 5 créditos, 3 meses.</li>
            <li><strong>Pack 15 Anúncios</strong> — 15.000 CVE, 15 créditos em destaque, 6 meses.</li>
          </ul>
          <p>Os créditos são deduzidos no momento da publicação e expiram conforme a validade do pack adquirido. Créditos não utilizados dentro do prazo de validade não são reembolsáveis nem transferíveis.</p>

          <h2>6. Pagamentos e Facturação</h2>
          <p>Os pagamentos podem ser efectuados por:</p>
          <ul>
            <li><strong>Transferência Bancária</strong> para a conta indicada na página de checkout.</li>
            <li><strong>Cartão (vinti4 / VISA / Mastercard / American Express)</strong> via plataforma SISP — vinti4 (em activação).</li>
          </ul>
          <p>Após confirmação do pagamento, o Trabadju emite uma factura electrónica acessível na área pessoal do empregador. Todos os preços são apresentados em Escudos Cabo-Verdianos (CVE) e incluem todos os impostos aplicáveis.</p>

          <h2>7. Política de Reembolso</h2>
          <p>O empregador pode solicitar o <strong>reembolso integral até 24 horas</strong> após a aprovação da compra, desde que <strong>nenhum crédito tenha sido utilizado</strong>. Após a utilização de qualquer crédito (publicação de qualquer anúncio), a compra deixa de ser reembolsável.</p>
          <p>Os pedidos de reembolso devem ser enviados para <a href={`mailto:${T.email_support}`}>{T.email_support}</a> com a indicação do número de factura.</p>

          <h2>8. Conteúdo dos Anúncios</h2>
          <p>O empregador é o único responsável pelo conteúdo dos anúncios que publica e garante:</p>
          <ul>
            <li>Veracidade das informações (cargo, requisitos, salário, localização);</li>
            <li>Inexistência de discriminação por género, raça, religião, idade ou orientação sexual;</li>
            <li>Conformidade com a legislação laboral cabo-verdiana;</li>
            <li>Não publicação de esquemas piramidais, fraudes ou conteúdo ilegal.</li>
          </ul>
          <p>O Trabadju reserva-se o direito de remover anúncios que violem estas regras, sem reembolso.</p>

          <h2>9. Conduta dos Utilizadores</h2>
          <p>É proibido:</p>
          <ul>
            <li>Criar contas falsas ou usurpar identidade;</li>
            <li>Recolher dados de outros utilizadores para fins não autorizados;</li>
            <li>Utilizar a plataforma para fins ilícitos ou para enviar comunicações não solicitadas;</li>
            <li>Tentar aceder, modificar ou interferir com a infra-estrutura técnica do Trabadju.</li>
          </ul>

          <h2>10. Limitação de Responsabilidade</h2>
          <p>O Trabadju actua exclusivamente como intermediário tecnológico entre empregadores e candidatos. <strong>Não é parte de qualquer relação laboral</strong> que daí resulte e não garante a contratação, idoneidade do empregador, veracidade dos CVs, nem o resultado de qualquer processo de selecção.</p>

          <h2>11. Propriedade Intelectual</h2>
          <p>Todo o conteúdo do Trabadju (marca, logótipo, código, design, textos) é propriedade de {T.legal_name} e está protegido por direitos de autor. É proibida a reprodução total ou parcial sem autorização expressa.</p>

          <h2>12. Suspensão e Cancelamento</h2>
          <p>O Trabadju pode suspender ou cancelar contas que violem estes Termos, sem aviso prévio e sem direito a reembolso de créditos não utilizados.</p>

          <h2>13. Alterações aos Termos</h2>
          <p>Estes Termos podem ser alterados a qualquer momento. As alterações entram em vigor na publicação no site e os utilizadores serão notificados por email para alterações materiais.</p>

          <h2>14. Lei Aplicável e Foro</h2>
          <p>Estes Termos regem-se pela lei da República de Cabo Verde. Qualquer litígio será submetido aos tribunais da Cidade da Praia.</p>

          <h2>15. Contacto</h2>
          <p>Para questões sobre estes Termos: <a href={`mailto:${T.email_legal}`}>{T.email_legal}</a></p>
        </article>
      </div>
    </div>
  );
}
